//Archivo de configuración de la ruta de la API.

const settings = {
    API_URL: process.env.REACT_APP_API_URL,
};

export default settings;
